import * as Rx from 'rxjs';
import {
  CollectionHasTotalCount,
  LegacySearchCollections,
} from '../collections.model';

export class DatastoreSearchCollection<
  K extends keyof LegacySearchCollections
> {
  constructor(
    // public status$: Rx.Observable<RequestStatus<K>>,
    private valueChanges$: Rx.Observable<
      ReadonlyArray<LegacySearchCollections[K]>
    >,
    private approximateTotalCount$: Rx.Observable<
      CollectionHasTotalCount[K] extends true ? number : undefined
    >,
  ) {}

  valueChanges(): Rx.Observable<ReadonlyArray<LegacySearchCollections[K]>> {
    return this.valueChanges$;
  }

  approximateTotalCount(): Rx.Observable<
    CollectionHasTotalCount[K] extends true ? number : undefined
  > {
    return this.approximateTotalCount$;
  }
}
